var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('p',[_vm._v(" Authorizing..."),_c('br'),_vm._v(" Please wait for a moment... ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }